<template>
    <DModal
        :show="showModal"
        :title="title"
        is-confirm
        :is-awaiting-validation="true"
        @update:show="$emit('update:showModal', $event)"
        @confirm="saveReason"
        @close="$emit('close-modal')"
    >
        <DCard padding>
            <DFormRow
                :label="__('orders.check.manual_checks_tab.comment')"
                :is-required="commentRequired"
                :error="errors.comment"
            >
                <DInput
                    id="order-comment"
                    v-model="form.comment"
                />
                <p
                    v-if="errors.status"
                    class="error-msg"
                >
                    {{ errors.status }}
                </p>
            </DFormRow>
        </DCard>
    </DModal>
</template>

<script>

export default {
    name: 'OrderCommentModal',
    props: {
        order: {
            type: Object,
            default: () => { return {} }
        },
        action: {
            type: String,
            default: () => { return null }
        },
        title: {
            type: String,
            default: () => { return null }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        commentRequired: {
            type: Boolean,
            default: true
        }
    },
    emits: ['close-modal', 'update:showModal'],
    data () {
        return {
            form: this.$inertia.form({
                action: this.action,
                commentRequired: this.commentRequired,
                comment: null
            }),
            errors: {}
        }
    },
    methods: {
        saveReason () {
            this.$inertia.post(
                this.$route('orders.psa.change-status', {
                    order: this.order.orderData.id
                })
                ,
                this.form,
                {
                    onSuccess: () => {
                        this.$emit('close-modal')
                    },
                    onError: (error) => {
                        this.errors = error
                    }
                }
            )
        }
    }
}
</script>

<style scoped>
.error-msg {
    margin: 3px 0 0 0;
    font-size: 12px;
    color: var(--colorDanger);
}
</style>
